export const ROUTES = {
  DASHBOARD: "/dashboard",
  DASH: {
    PREFIX: "/dash",
    INDEX: "/dash",
  },
  AUTH: {
    PREFIX: "/",
    LOGIN: "/login",
    REGISTER: "/register",
    CONFIRM_TOTP: "/confirm-totp",
    CONFIRM_EMAIL: "/confirm-email/:uuid",
    SSO: "/sso",
    VERIFIED: "/verified",
    RESET_PASSWORD: "/reset-password",
    NO_ACCOUNT: "/no-account",
    UNCONFIRMED_LEADS: "/unconfirmed-leads/:uuid",
    ACCEPT_INVITE: "/accept-invite/:uidb64/:token",
  },
  ONBOARD: {
    PREFIX: "/onboard",
    INDEX: "/onboard",
    CREATE_NUMBER: "/onboard/create-number",
    WHATSAPP_SETUP: "/onboard/whatsapp-setup",
    API_DOC: "/onboard/api-doc",
    SETUP_PAYMENT: "/onboard/setup-payment",
  },
  QUICK_METRICS: {
    PREFIX: "/quick-metrics",
    INDEX: "/quick-metrics/calls",
    CALLS: "/quick-metrics/calls",
    MESSAGES: "/quick-metrics/messages",
    WHATSAPP_LEADS: "/quick-metrics/whatsapp-leads",
  },
  CALLS: {
    PREFIX: "/calls",
    INDEX: "/calls",
    // The old Received / Made / Blocked tabs, kept so bookmarks redirect.
    LEGACY_TABS: ["/calls/received", "/calls/made", "/calls/blocked"],
  },
  MESSAGES: {
    PREFIX: "/messages",
    INDEX: "/messages/received",
    SENT: "/messages/sent",
    RECEIVED: "/messages/received",
    BLOCKED: "/messages/blocked",
  },
  NUMBERS: {
    PREFIX: "/numbers",
    INDEX: "/numbers",
  },
  PHONE_USERS: {
    PREFIX: "/phone-users",
    INDEX: "/phone-users",
    CREATE: "/phone-users/create",
    EDIT: "/phone-users/:uuid/edit",
  },
  WHATSAPP: {
    PREFIX: "/whatsapp",
    INDEX: "/whatsapp/accounts",
    ACCOUNTS: {
      PREFIX: "/whatsapp/accounts",
      INDEX: "/whatsapp/accounts",
      DETAILS: "/whatsapp/accounts/:id",
      SETUP: "/whatsapp/accounts/setup",
    },
    DOCUMENTATION: {
      PREFIX: "/whatsapp/documentation",
      INDEX: "/whatsapp/documentation",
    },
    CHAT_INTROS: {
      PREFIX: "/whatsapp/chat-intros",
      INDEX: "/whatsapp/chat-intros",
    },
    CHAT_LOGS: {
      PREFIX: "/whatsapp/chat-logs",
      INDEX: "/whatsapp/chat-logs",
    },
    CAMPAIGNS: {
      PREFIX: "/whatsapp/campaigns",
      INDEX: "/whatsapp/campaigns",
      CREATE: "/whatsapp/campaigns/create",
      EDIT: "/whatsapp/campaigns/:uuid/edit",
    },
    OPT_OUTS: {
      PREFIX: "/whatsapp/opt-outs",
      INDEX: "/whatsapp/opt-outs",
      CREATE: "/whatsapp/opt-outs/create",
    },
    LISTS: {
      PREFIX: "/whatsapp/lists",
      INDEX: "/whatsapp/lists",
    },
  },
  OPTIONS: {
    PREFIX: "/more",
    INDEX: "/more/whatsapp",
    WHATS_APP: "/more/whatsapp",
  },
  DEVELOPER: {
    PREFIX: "/developer",
    INDEX: "/developer/documentation",
    DOCUMENTATION: "/developer/documentation",
    API_TOKENS: {
      INDEX: "/developer/api-tokens",
      PREFIX: "/developer/api-tokens",
      CREATE: "/developer/api-tokens/create",
      EDIT: "/developer/api-tokens/:apiTokenId/edit",
    },
    WEBHOOKS: {
      INDEX: "/developer/webhooks",
      PREFIX: "/developer/webhooks",
      CREATE: "/developer/webhooks/create",
      EDIT: "/developer/webhooks/:id/edit",
    },
  },
  ERROR_REPORTING: {
    PREFIX: "/error_reporting",
    INDEX: "/error_reporting/current_errors",
    CURRENT_ERRORS: {
      INDEX: "/error_reporting/current_errors",
      PREFIX: "/error_reporting/current_errors",
      DETAILS: "/error_reporting/current_errors/:id",
    },
    ERROR_NOTIFICATIONS: {
      INDEX: "/error_reporting/error-notifications",
      PREFIX: "/error_reporting/error-notifications",
      CREATE: "/error_reporting/error-notifications/create",
      EDIT: "/error_reporting/error-notifications/:id/edit",
    },
  },
  SETTINGS: {
    PREFIX: "/settings",
    INDEX: "/settings/profile",
    PROFILE: "/settings/profile",
    USERS: {
      PREFIX: "/settings/users",
      INDEX: "/settings/users",
      CREATE: "/settings/users/invite",
      EDIT: "/settings/users/:id/edit",
    },
    PROJECTS: {
      PREFIX: "/settings/projects",
      INDEX: "/settings/projects",
      CREATE: "/settings/projects/create",
      EDIT: "/settings/projects/:id/edit",
    },
    BILLING: {
      PREFIX: "/settings/billing",
      INDEX: "/settings/billing",
      CARD: "/settings/billing/card",
      AUTO_RECHARGING: "/settings/billing/auto-recharging",
      ADD_FUNDS: "/settings/billing/add-funds",
    },
    INVOICES: {
      PREFIX: "/settings/invoices",
      INDEX: "/settings/invoices",
    },
    BLOCKED_NUMBERS: {
      PREFIX: "/settings/blocked-numbers",
      INDEX: "/settings/blocked-numbers",
      CREATE: "/settings/blocked-numbers/create",
      EDIT: "/settings/blocked-numbers/:id/edit",
    },
    BLOCKED_KEYWORDS: {
      PREFIX: "/settings/blocked-keywords",
      INDEX: "/settings/blocked-keywords",
      CREATE: "/settings/blocked-keywords/create",
      EDIT: "/settings/blocked-keywords/:id/edit",
    },
    AUDIO_FILES: {
      PREFIX: "/settings/audio-files",
      INDEX: "/settings/audio-files",
      CREATE: "/settings/audio-files/create",
      EDIT: "/settings/audio-files/:type/:name/edit",
    },
    SUMI: {
      PREFIX: "/settings/sumi",
      // Must NOT equal PREFIX: Sumi/routing.tsx redirects PREFIX -> INDEX, so
      // the two being the same string made /settings/sumi redirect to itself.
      // Nothing linked there while Sumi was a sub-menu (sub-menu.tsx derives a
      // parent's link from its first child), but the Dashboard news feed pushes
      // INDEX for a "sumi" card, and SD-4167 promotes Sumi to a top-level item
      // that needs a landing page of its own.
      INDEX: "/settings/sumi/learn-more",
      CALL_INSIGHTS: {
        PREFIX: "/settings/sumi/call-insights",
        INDEX: "/settings/sumi/call-insights",
        CREATE: "/settings/sumi/call-insights/create",
        EDIT: "/settings/sumi/call-insights/:id/edit",
      },
      LEARN_MORE: "/settings/sumi/learn-more",
      VOICE_AGENTS: {
        PREFIX: "/settings/sumi/voice-agents",
        INDEX: "/settings/sumi/voice-agents",
        CREATE: "/settings/sumi/voice-agents/create",
        EDIT: "/settings/sumi/voice-agents/:id/edit",
        VIEW: "/settings/sumi/voice-agents/:id",
      },
    },
    INTEGRATIONS: {
      PREFIX: "/settings/integrations",
      INDEX: "/settings/integrations",
      GA4: {
        PREFIX: "/settings/integrations/ga4",
        INDEX: "/settings/integrations/ga4",
        CREATE: "/settings/integrations/ga4/create",
        EDIT: "/settings/integrations/ga4/:id/edit",
      },
      ELEVENLABS: {
        PREFIX: "/settings/integrations/elevenlabs",
        INDEX: "/settings/integrations/elevenlabs",
      },
    },
    TAGS: "/settings/tags",
    TFA: "/settings/two-factor-auth",
  },

  PUBLIC: {
    TERMS_CONDITIONS: "/terms-conditions",
    PRIVACY_POLICY: "/privacy-policy",
  },
};
